exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2z3_D8eMK-x6FRCJ0nFrWD {\n    font-weight: 600;\n    margin-bottom: 0;\n}", ""]);

// exports
exports.locals = {
	"root": "_2z3_D8eMK-x6FRCJ0nFrWD"
};